// extracted by mini-css-extract-plugin
export default {"BoxSlider":"qF4icoG_YzpkrnAOT1T_","BoxSlider__title":"yaeGMmloyBHCAq6yEEhL"};